module.exports = __webpack_public_path__ + "static/img/IMG_20241023_110429.7c7cac94.jpg";